import Stack from '@mui/material/Stack';
import { CenteredCircularProgress } from '../../../common/CenteredCircularProgress';

interface SearchLoadingOverlayProps {
  isVisible: boolean;
}

export const SearchLoadingOverlay = ({ isVisible }: SearchLoadingOverlayProps) => {
  if (!isVisible) return null;

  return (
    <Stack
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bgcolor="rgba(255, 255, 255, 0.8)"
      zIndex={10}
      alignItems="center"
      justifyContent="center"
    >
      <CenteredCircularProgress />
    </Stack>
  );
};
